/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Sub_Addons_Confirm_Upgrade_DescInputs */



/**
* | output |
* | --- |
* | "A prorated charge of approximately €{price} will be added to your current invoice. Your previous tier credit will be applied." |
*
* @param {Sub_Addons_Confirm_Upgrade_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_upgrade_desc = /** @type {((inputs: Sub_Addons_Confirm_Upgrade_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Upgrade_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Eine anteilige Gebühr von ca. €${i?.price} wird Ihrer aktuellen Rechnung hinzugefügt. Ihr bisheriges Guthaben wird angerechnet.`)
	return /** @type {LocalizedString} */ (`A prorated charge of approximately €${i?.price} will be added to your current invoice. Your previous tier credit will be applied.`)
});